import { IonInput, IonLabel, IonSegment, IonSegmentButton } from '@ionic/react';
import { useCallback, useEffect, useState, useRef } from 'react';
import buildStyle from '../build-path.module.scss';
import './serato.scss';
import ImportCrates from './import-crates';
import ImportHistory from './import-history';
import { iTrack } from '../../../../types/ITrack';
import BuildGenerateCrate from '../../build-generate-crate/build-generate-crate';

export default function SeratoPath() {
  const [activeSegment, setActiveSegment] = useState('history');
  const [crateName, setCrateName] = useState('');
  const [crateDescription, setCrateDescription] = useState('');
  const [trackList, setTrackList] = useState<iTrack[]>([]);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const userEditedName = useRef(false);

  const buildCrate = useCallback(
    () => ({
      _id: '',
      Title: crateName,
      Description: crateDescription,
      Tracks: trackList,
      createdFrom: 'Serato',
    }),
    [crateName, crateDescription, trackList],
  );

  // Auto-fill crate name from child component (only if user hasn't manually edited)
  const setSuggestedCrateName = useCallback((name: string) => {
    if (!userEditedName.current) {
      setCrateName(name);
    }
  }, []);

  // Track when user manually edits the crate name
  const handleCrateNameChange = (value: string) => {
    userEditedName.current = true;
    setCrateName(value);
  };

  useEffect(() => {
    setCrateDescription('');
    setTrackList([]);
    // Reset user edited flag when switching segments
    userEditedName.current = false;
    setCrateName('');
  }, [activeSegment]);

  useEffect(() => {
    setIsBtnDisabled(!crateName || trackList.length === 0);
  }, [crateName, trackList]);

  return (
    <>
      <div className={buildStyle.buildHeader}>
        <div>What should we name your crate?</div>
      </div>

      <IonInput
        className={buildStyle['build-input']}
        labelPlacement="floating"
        fill="outline"
        value={crateName}
        onIonInput={(e) => {
          handleCrateNameChange(e.detail.value!);
        }}
      >
        <div slot="label">Crate Name</div>
      </IonInput>

      <IonSegment value={activeSegment} style={{ marginBottom: '25px' }}>
        <IonSegmentButton
          value="history"
          onClick={() => setActiveSegment('history')}
        >
          <IonLabel>Import from Serato History</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton
          value="crates"
          onClick={() => setActiveSegment('crates')}
        >
          <IonLabel>Import from Serato Crate</IonLabel>
        </IonSegmentButton>
      </IonSegment>

      {activeSegment === 'history' && (
        <ImportHistory
          setCrateDescription={setCrateDescription}
          setTrackList={setTrackList}
          setSuggestedCrateName={setSuggestedCrateName}
        />
      )}
      {activeSegment === 'crates' && (
        <ImportCrates
          setCrateDescription={setCrateDescription}
          setTrackList={setTrackList}
          setSuggestedCrateName={setSuggestedCrateName}
        />
      )}

      <BuildGenerateCrate
        buildCrateFn={buildCrate}
        isBtnDisabled={isBtnDisabled}
      />
    </>
  );
}
